<template>
  <div id="recomendationsContainer" class="container-fluid">
    <div class="row">
      <div class="col-xs-12">
        <h2 class="text-xs-center">
          <a v-on:click="scrollToRecomendations"><i class="fa fa-angle-down" aria-hidden="true"></i></a>
          <div>{{t('Our recomendations')}}</div>
        </h2>
      </div>
    </div>
    <div class="recomendationList row m-t-3">
      <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4 recomendation m-b-2" v-for="recomendation in recomendations">
        <router-link :to="'/'+language+'/activity/'+recomendation.slug">
          <ActivityCard :activity="recomendation" :headerIcons="false" class="sameHeight"></ActivityCard>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import MatchHeight from 'jquery-match-height'; // eslint-disable-line
import { mapState, mapActions } from 'vuex';
import ActivityCard from '../Activity/ActivityCard';

const $ = window.$;

export default {
  name: 'Recomendations',
  components: { ActivityCard },
  computed: {
    ...mapState({
      recomendations: state => state.recomendations.data,
      language: state => state.language,
    }),
  },
  methods: {
    ...mapActions({
      getRecomendations: 'recomendations/get',
    }),
    scrollToRecomendations() {
      window.jQuery('html, body').animate({
        scrollTop: window.jQuery('#recomendationsContainer').offset().top,
      }, 800);
    },
  },
  mounted() {
    this.getRecomendations().then(() => {
      $('.sameHeight').matchHeight();
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../../static/MDB-PRO/sass/mdb/free/data/colors";
@import "../../assets/scss/variables";
.view {
  background: #333;
}

h4 {
  min-height: 58px;
}
.view {

  min-height: 191px;
}

.fa-angle-down {
  font-size: 70px;
}
.fa-chevron-right {
  margin-top: 3px;
  line-height: 42px;
}

.recomendations .recomendation {
  display: inline-block;
  float: none !important;
}

.btn-action {
  background-color: $primary-color-dark;
}
</style>



// WEBPACK FOOTER //
// Recomendations.vue?2397e8d9